import { render, staticRenderFns } from "./ProductSubCategorys.vue?vue&type=template&id=4f9d9fa3&"
import script from "./ProductSubCategorys.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategorys.vue?vue&type=script&lang=js&"
import style0 from "./ProductSubCategorys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports